import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

type DeleteExportMethodParams = {
	exportId: string;
};

export default function useDeleteExportMethod(shop: ShopDto) {
	/**
	 * It will not work with the current popup implementation
	 */
	return useApiMutation("delete", "/shops/{shopId}/exports/{exportId}", {
		mapVariables: ({ exportId }: DeleteExportMethodParams) => ({
			params: { path: { shopId: shop.id, exportId } },
		}),
	});
}
